module.exports = __webpack_public_path__ + "static/media/set.6d47bb78.svg";